export const getBoolean = (value: any) => {
  return !!JSON.parse(String(value).toLowerCase());
};

export const getAuthorizedFromDelious = () => {
  return process.env.REACT_APP_IS_AUTHORIZED_FROM_DELIOUS === "true" || false;
};
